import axios from 'axios';

const { REACT_APP_API_HOST } = process.env;

export const uploadFile = (file: File) => {
  const formData = new FormData();
  formData.append('photo', file);
  return axios.post(`${REACT_APP_API_HOST}/file/upload`, formData);
};
